module.exports = __webpack_public_path__ + "static/media/FormIt Pro.35c41869.png";